<section [@routerTransition]>
    <div class="row">
        <div class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="input-group d-flex flex-column mr-2">
                <label for="substancia" class="mb-1">Substância ou agente causador</label>
                <div class="input-group">
                    <img class="input-group-text" src="../../../../assets/img/icons/search.svg" alt="Busca">
                    <input id="substancia" type="text" [(ngModel)]="request.substancia" class="busca-nome"
                        (input)="refresh()">
                </div>
            </div>

            <div class="d-flex flex-column mx-2 select-container">
                <label for="tipoAlergia" class="mb-1">Tipo de alergia</label>
                 <select class="alergia-select" name="tipoAlergia" id="tipoAlergia" (change)="refresh()" [(ngModel)]="request.tipoAlergia">
                    <option *ngFor="let tipo of tiposAlergias.TiposAlergia" [value]="tipo.type">{{tipo.name}}</option>
                </select>
            </div>
        </div>
        <div class="col p-0 d-flex justify-content-end">
            <button class="btn primary-white-button" (click)="create()">
                Cadastrar
                <i class="hgi hgi-stroke hgi-plus-sign-circle"></i>
            </button>
        </div>
    </div>

    <div class="row">
        <button class="btn btn-filtros" (click)="limparFiltro()">
            Limpar filtros
            <i class="hgi hgi-stroke hgi-delete-02 ml-1"></i>
        </button>
    </div>

    <div class="table-container table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>Substância ou agente causador</th>
                    <th>Tipo de alergia</th>
                    <th>Observação</th>
                    <th>Ação</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="
                let alergia of alergias
                  | paginate
                    : {
                        id: 'server',
                        itemsPerPage: pageSize,
                        currentPage: pageNumber,
                        totalItems: totalItems
                      }
                ">
                    <td>{{alergia.substancia}}</td>
                    <td>{{alergia.tipoAlergiaString}}</td>
                    <td>{{alergia.observacao}}</td>
                    <td>
                        <div class="row d-flex flex-row">
                           <button *ngIf="alergia.creatorUserId === appSession.userId" class="btn icon icon-edit mr-2" title="Editar alergia" (click)="edit(alergia)">
                                <i class="hgi hgi-stroke hgi-pencil-edit-02"></i>
                            </button>
                           <button *ngIf="alergia.creatorUserId === appSession.userId" class="btn icon icon-danger" title="Apagar alergia" (click)="delete(alergia)">
                                <i class="hgi hgi-stroke hgi-delete-02"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="float-sm-right m-auto">
                <abp-pagination-controls id="server" (pageChange)="getDataPage($event)">
                </abp-pagination-controls>
            </div>
        </div>
    </div>
</section>